<template>
  <v-navigation-drawer
      app
      clipped
      right
      v-model="RIGHT_ONBOARDING_DRAWER_STATE"
      :mini-variant="isMini"
      permanent
      mini-variant-width="50"
      :class="{'drawer-mini': !RIGHT_ONBOARDING_DRAWER_STATE}"
      width="440"
  >
    <div v-show="!isMini">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs}">
          <v-btn class="pa-5" icon @click.stop="TOOGLE_RIGHT_ONBOARDING_DRAWER_STATE" v-bind="attrs" v-on="on">
            <v-icon color="primary">close</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons:close-sidebar')}}</span>
      </v-tooltip>
    </div>
    <div v-show="isMini" class="text-center">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs}">
          <v-btn class="pa-5" icon @click.stop="TOOGLE_RIGHT_ONBOARDING_DRAWER_STATE" v-bind="attrs" v-on="on">
            <v-icon color="primary">link</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons:open-sidebar')}}</span>
      </v-tooltip>
    </div>

    <v-divider></v-divider>

    <v-expansion-panels v-show="!isMini" tile accordion multiple v-model="panels">
      <!-- Facility Technical Info Panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>elevator</v-icon></v-col>
            <v-col cols="6">
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('book/public:qrcode.onboarding.info-title') }}</span>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="(item, i) in technicalInfoSections" :key="i" @click="$emit('scrollToTechnic', {ref: item.ref, index: i})">
                <p class="mb-0">{{ item.name }}</p>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>insights</v-icon></v-col>
            <v-col cols="6">
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('book/public:qrcode.common.state') }}</span>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="(item, i) in stateSections" :key="i" @click="$emit('scrollToState', {ref: item.ref, index: i})">
                <p class="mb-0">{{ item.name }}</p>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-navigation-drawer>
</template>
<script>
import {mapActions, mapState} from "vuex";

export default {
  name: 'QRCodeFacilityOnboardingSidebar',
  props: {

  },
  data() {
    return {
      panels: [0, 1]
    }
  },
  computed: {
    ...mapState('book/layout', {
      rightOnboardingDrawer: state => state.rightOnboardingDrawer
    }),
    RIGHT_ONBOARDING_DRAWER_STATE: {
      get() {
        return this.rightOnboardingDrawer
      },
      set(newValue) {
        if (newValue === this.rightOnboardingDrawer) return;
        this.TOOGLE_RIGHT_ONBOARDING_DRAWER_STATE();
      }
    },
    isMini() {
      // if screen size is md or lower
      if(this.$vuetify.breakpoint.mdAndDown) {
        return this.RIGHT_ONBOARDING_DRAWER_STATE
      } else {
        return !this.RIGHT_ONBOARDING_DRAWER_STATE
      }
    },

    technicalInfoSections() {
      return [
        { name: this.$t('book/public:qrcode.onboarding.technical-info-title'), ref: 'panel_0'},
        { name: this.$t('book/technical-info:titles.installation'), ref: 'panel_1'},
        { name: this.$t('common:type'), ref: 'panel_2'},
        { name: this.$t('book/technical-info:titles.transport'), ref: 'panel_3'},
        { name: this.$t('book/technical-info:titles.story'), ref: 'panel_4'},
        { name: this.$t('book/technical-info:titles.key-safe') + ' & ' + this.$t('book/technical-info:titles.engine'), ref: 'panel_5'},
        { name: this.$t('book/technical-info:titles.emergency'), ref: 'panel_6'},
        { name: this.$t('book/technical-info:titles.cabin'), ref: 'panel_7'},
        { name: this.$t('book/technical-info:titles.shaft'), ref: 'panel_8'}
      ]
    },

    stateSections() {
      return [
        { name: this.$t('book/public:qrcode.data.state.panel-titles.docu'), ref: 'state_panel_0'},
        { name: this.$t('book/public:qrcode.data.state.panel-titles.car'), ref: 'state_panel_1'},
        { name: this.$t('book/public:qrcode.data.state.panel-titles.stop'), ref: 'state_panel_2'},
        { name: this.$t('book/public:qrcode.data.state.panel-titles.engine-room'), ref: 'state_panel_3'},
        { name: this.$t('book/public:qrcode.data.state.panel-titles.shaft'), ref: 'state_panel_4'},
        { name: this.$t('book/public:qrcode.data.state.panel-titles.shaft-pit'), ref: 'state_panel_5'},
        { name: this.$t('book/public:qrcode.onboarding.image-section'), ref: 'state_panel_6'},
        { name: this.$t('book/public:qrcode.data.state.panel-titles.summary'), ref: 'state_panel_7'}
      ]
    }
  },
  methods:{
    scrollTo(item) {
      setTimeout(() => {
        this.$vuetify.goTo(this.$refs[item.ref], {duration: 1000, offset: 100, easing: 'easeInOutCubic'})
      }, 250);
    },

    ...mapActions(
        'book/layout', ['TOOGLE_RIGHT_ONBOARDING_DRAWER_STATE']
    )
  }
}
</script>
<style lang="scss">
// css for right navigation bar
.v-navigation-drawer--right {
  .v-expansion-panels {
    z-index: 0;
  }
  .v-expansion-panel::before {
    box-shadow: 0 2px 1px 0 #e8eafc, 0 1px 1px -2px #b2b2b21a, 0 1px 1px 0 #9a9a9a1a;
  }
  .v-expansion-panel-header {
    padding: 0 16px;
    .row {
      width: 95%;
    }
  }

  .v-expansion-panel-header > *:not(.v-expansion-panel-header__icon) {
    flex: none!important;
  }
  .v-expansion-panel-content {
    .v-expansion-panel-content__wrap {
      padding: 0;

      .v-list {
        padding: 0;

        .v-list-item {
          padding: 4px 16px;
          background-color: rgba(246, 247, 255, 0.6);

          .v-avatar {
            border: 2px solid var(--v-scaleRed-base);
          }
        }
      }
    }
  }
}
</style>